<template>
  <div style="padding-top: 36px;">
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div
              v-if="loadingFirebaseUser"
              class="d-flex justify-content-center align-items-center p-9"
            >
              <h3>Cargando...</h3>
            </div>
            <div
              v-if="pending && !loadingFirebaseUser"
              class="d-flex justify-content-center align-items-center p-9"
            >
              <center>
                <i class="fa fa-clock fa-3x" aria-hidden="true"></i>
                <h3 class="py-5">
                  Tu registro esta en proceso de validación. Un agente de ventas
                  se contactará contigo.
                </h3>
              </center>
            </div>
            <div class="" v-if="!pending && !loadingFirebaseUser">
              <div class="card-header" style="align-items: flex-start;">
                Mis Facturas ({{ invoices.length }})
              </div>
              <div class="table-header">
                <span class="table-header-item"># Factura</span>
                <span class="table-header-item">Fecha</span>
                <span class="table-header-item">Descargar PDF</span>
                <span class="table-header-item">Descargar XML</span>
              </div>
              <div class="table-content">
                <div
                  class="table-content-row"
                  v-for="(item, id) in invoices"
                  :key="id"
                >
                  <span class="table-content-item">{{ item.DocNum }}</span>
                  <span class="table-content-item">{{ item.DocDate }}</span>
                  <div class="table-content-item ">
                    <button :disabled="downloadingPDF.includes(item.DocEntry)" @click="openFile(item, 'pdf')" class="tab-item-button"><i class="fas fa-arrow-down"></i> Descargar</button>
                  </div>
                  <div class="table-content-item ">
                    <button :disabled="downloadingXML.includes(item.DocEntry)" @click="openFile(item, 'xml')" class="tab-item-button"><i class="fas fa-arrow-down"></i> Descargar</button>
                  </div>
                </div>
              </div>
              <!-- <div class="card-body px-0 pt-0">
                <div class="table-responsive">
                  <base-table thead-classes="thead-light" :data="invoices">
                    <template v-slot:default="{ row, index }">
                      <th scope="row">{{ row.DocNum }}</th>
                      <th scope="row">{{ row.DocDate }}</th>
                      <th scope="row">
                        <base-button
                          icon="fa fa-file-pdf fa-lg"
                          type="secondary"
                          iconOnly
                          @click="openFile(row, 'pdf')"
                          :disabled="downloadingPDF.includes(row.DocEntry)"
                        >
                        </base-button>
                      </th>
                      <th scope="row">
                        <base-button
                          icon="fa fa-file-code fa-lg"
                          type="secondary"
                          iconOnly
                          @click="openFile(row, 'xml')"
                          :disabled="downloadingXML.includes(row.DocEntry)"
                        >
                        </base-button>
                      </th>
                    </template>
                  </base-table>
                </div>
                <center v-if="!invoices" class="p-7">
                  <h3>Cargando...</h3>
                </center>
                <div v-if="invoices && showMoreInv" class="card-body">
                  <base-button
                    block
                    @click="loadMoreInvoices()"
                    :disabled="loadingInv"
                  >
                    Cargar más...
                  </base-button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import axios from "axios";

export default {
  data() {
    return {
      business_partner: null,
      invoices: null,
      showMoreInv: false,
      loadingInv: false,
      downloadingPDF: [],
      downloadingXML: [],
      skip: 0,
      loadingFirebaseUser: false,
      pending: false,
      user: null,
      rfc: null,
    };
  },
  methods: {
    load() {
      this.rfc = localStorage.getItem("rfc");

      axios.get(`/api/business_part/${this.rfc}`).then((result) => {
        this.business_partner = result.data.value[0];
        this.skip = 0;
        axios
          .get(
            `/api/invoices/customer?card_code=${
              this.business_partner.CardCode
            }&skip=${this.skip}`
          )
          .then((result) => {
            this.invoices = result.data.value;
            this.showMoreInv = result.data.value.length < 20 ? false : true;
          });
      });

      this.loadingFirebaseUser = true;
      firebase
        .firestore()
        .collection("NuevosClientes")
        .where("f_rfc", "==", this.rfc)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            this.pending = true;
          }
          this.loadingFirebaseUser = false;
        });
    },
    loadMoreInvoices() {
      this.skip += 20;
      this.loadingInv = true;
      axios
        .get(
          "/api/invoices/customer?card_code=" +
            this.business_partner.CardCode +
            "&skip=" +
            this.skip
        )
        .then((result) => {
          this.invoices = this.invoices.concat(result.data.value);
          this.showMoreInv = result.data.value.length < 20 ? false : true;
          this.loadingInv = false;
        });
    },
    openFile(invoice, file) {
      if (file === "pdf") {
        this.downloadingPDF.push(invoice.DocEntry);
      } else if (file === "xml") {
        this.downloadingXML.push(invoice.DocEntry);
      }
      axios
        .post(
          `/api/electronic_communication/emc_actions?doc_entry=${
            invoice.DocEntry
          }`,
          {}
        )
        .then((result) => {
          if (result.data.sl_err) {
            this.$swal(
              "",
              "Esta factura aún no se encuentra disponible. Intenta de nuevo más tarde.",
              "info"
            );
            if (file === "pdf") {
              this.downloadingPDF.splice(
                this.downloadingPDF.indexOf(invoice.DocEntry),
                1
              );
            } else if (file === "xml") {
              this.downloadingXML.splice(
                this.downloadingXML.indexOf(invoice.DocEntry),
                1
              );
            }
          } else {
            var json = {
              month: invoice.DocDate.substr(5, 2),
              year: invoice.DocDate.substr(0, 4),
              day: invoice.DocDate.substr(8, 2),
              card_code: invoice.CardCode,
              card_name: invoice.CardName,
              uuid: result.data.ReportID,
              file_type: file,
            };
            axios
              .post("/api/ubuntu_files/invoices", json, {
                responseType: "blob",
              })
              .then((result) => {
                var link = document.createElement("a");
                link.download = json.uuid + "." + file;
                link.href = URL.createObjectURL(result.data);
                link.click();
                URL.revokeObjectURL(link.href);
                if (file === "pdf") {
                  this.downloadingPDF.splice(
                    this.downloadingPDF.indexOf(invoice.DocEntry),
                    1
                  );
                } else if (file === "xml") {
                  this.downloadingXML.splice(
                    this.downloadingXML.indexOf(invoice.DocEntry),
                    1
                  );
                }
              });
          }
        });
    },
  },
  mounted() {
    this.load();
  },
  created() {
    this.user = firebase.auth().currentUser;
    firebase
      .auth()
      .currentUser.getIdToken(/* forceRefresh */ true)
      .then(function(idToken) {
        fetch("https://canplast.net:50000/api/v1/auth/verifyToken", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: idToken,
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            localStorage.setItem("token-cpm", responseJson.token);
          })
          .catch((error) => {
            this.$swal("Error", error, "error");
          });
      })
      .catch(function(error) {
        this.$swal("Error", error, "error");
      });
  },
};
</script>

<style>
/* .container-fluid {
  mart
} */
.card {
  min-height: 80vh;
  border-radius: 24px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  padding: 24px;
  font-size: 18px;
  font-weight: 700;
  background-color: #f6f9fc;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 0px 12px;
  height: 45px;
  background-color: #f6f9fc;
}

.table-header-item {
  flex: 1;
  border-right: 1px solid #c9cdd180;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 0px 12px;
  font-size: 14px;
}

.table-header-item:last-of-type {
  border: none;
}

.table-content {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  max-height: 70vh;
  overflow: auto;
}

.table-content-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  min-height: 35px;
  box-sizing: border-box;
  padding: 0px 12px;
}

.table-content-row:nth-child(even) {
  background-color: #f6f9fc80; /* Color para filas pares */
}

.table-content-row:nth-child(odd) {
  background-color: #ffffff; /* Color para filas impares */
}

.table-content-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  padding: 0px 12px;
}

.tab-item-button {
  background-color: #E9ECEF80;
  border: none;
  border-radius: 16px;
  padding: 0px 16px;
  height: 22px;
  /* box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1); */
  font-weight: 600;
  color: #00000040;
  transition: all 0.3s ease;
}

.fa-arrow-down {
  margin-right: 8px;
}

.tab-item-button:hover {
  background-color: #f53d57;
  color: #FFF;
}
</style>
